
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns1a2a35dcf42fbf4ec6086336337978e8en from './en.yaml'
            i18n.addResourceBundle('en', '1a2a35dcf42fbf4ec6086336337978e8', flattenObject(ns1a2a35dcf42fbf4ec6086336337978e8en), true, true);
        
        export default '1a2a35dcf42fbf4ec6086336337978e8';
    